<!--If component data exists-->
<!--{{ registrationStartComponentData$ | async | json }}-->
@if (registrationStartComponentData$ | async; as data) {
  <ng-container class="registration-start">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 px-2">
        <!--  <h2 class="registration-start__title text-center">{{ 'efaRegistrationStart.headline' | cxTranslate }}</h2>-->
        @if (data.text1) {
          <div [innerHTML]="data.text1" class="registration-start__text1"></div>
        }
        @if (downloadLinksData$ | async) {
          <div class="registration-start__links container">
            <ul class="row p-0">
              @for (link of downloadLinksItems; track link) {
                <li class="col-12 col-md-6 mb-1 p-0">
                  <cx-generic-link
                    [url]="getExternal(link) ? link.url : getUrl(link.url)"
                    [style]="link.styleAttributes"
                    [target]="getTarget(link)">
                    <cx-icon [type]="iconTypes.DOWNLOAD_BLUE"></cx-icon>
                    {{ link.linkName }}
                  </cx-generic-link>
                </li>
              }
            </ul>
          </div>
        }
        <hr>
          @if (data.text2) {
            <div [innerHTML]="data.text2" class="registration-start__text2"></div>
          }
          @if ((displayButton$ | async) === 'true') {
            <div class="row">
              <div class="col-md-4">
                <button [routerLink]="{ cxRoute: 'registration' } | cxUrl"
                  type="button"
                  class="btn btn-block btn-primary">
                  {{ 'efaRegistrationStart.continueToRegistration' | cxTranslate }}
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </ng-container>
  }
